import styled, { css } from "styled-components";

interface StyledTableCellItemProps {
    $withEllipsis?: boolean;
    $maxLines?: number;
}

const StyledTableCellItem = styled.div<StyledTableCellItemProps>`
    margin: 5px 0;

    ${(props) =>
        props.$withEllipsis &&
        css`
            text-overflow: ellipsis;
            overflow: hidden;
        `}
    ${(props) =>
        props.$withEllipsis &&
        props.$maxLines === 1 &&
        css`
            white-space: nowrap;
        `}

    ${(props) =>
        props.$maxLines !== 1 &&
        css`
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: ${props.$maxLines};
            -webkit-box-orient: vertical;
        `}
`;

StyledTableCellItem.defaultProps = {
    $withEllipsis: true,
    $maxLines: 1,
};

export default StyledTableCellItem;
